/* Suggestion de langue (Pataroc, agent Visuel, 17/10/2026) : voir snippets/pr-langue.liquid.
   Propose la langue du navigateur si le site l'a et que la page est dans une autre langue. Jamais de redirection.
   Les textes sont écrits dans la langue PROPOSÉE (un visiteur germanophone sur la page française lit de l'allemand) :
   ils ne peuvent donc pas venir des fichiers de langue de la page. */
(function () {
  var box = document.querySelector('[data-pr-lang]');
  if (!box) return;
  if (window.Shopify && window.Shopify.designMode) return; // pas dans l'éditeur de thème
  // pas pour les robots d'indexation ni les navigateurs pilotés (le texte ne doit pas finir dans l'index de la page)
  if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent || '')) return;

  var T = {
    fr: { label: 'Langue du site', text: 'Ce site existe aussi en français.', go: 'Voir en français', no: 'Non merci', close: 'Fermer' },
    en: { label: 'Site language', text: 'This site is also available in English.', go: 'View in English', no: 'No thanks', close: 'Close' },
    de: { label: 'Sprache der Website', text: 'Diese Website gibt es auch auf Deutsch.', go: 'Auf Deutsch ansehen', no: 'Nein danke', close: 'Schließen' },
    es: { label: 'Idioma del sitio', text: 'Este sitio también está disponible en español.', go: 'Ver en español', no: 'No, gracias', close: 'Cerrar' },
    it: { label: 'Lingua del sito', text: 'Questo sito è disponibile anche in italiano.', go: 'Vedi in italiano', no: 'No, grazie', close: 'Chiudi' },
    nl: { label: 'Taal van de website', text: 'Deze website is ook beschikbaar in het Nederlands.', go: 'Bekijk in het Nederlands', no: 'Nee, bedankt', close: 'Sluiten' }
  };
  var DONE = 'pr_lang_done', SEEN = 'pr_lang_seen', LAST = 'pr_lang_last';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function base(code) { return String(code || '').toLowerCase().split('-')[0]; }

  var roots;
  try { roots = JSON.parse(box.getAttribute('data-roots') || '{}'); } catch (e) { return; }
  var current = base(box.getAttribute('data-current'));

  // le visiteur a changé de langue lui-même (sélecteur de l'en-tête, lien) : son choix compte, on ne propose plus rien
  var last = ss(LAST);
  ss(LAST, current);
  if (last && last !== current) ls(DONE, '1');
  if (ls(DONE) || (Number(ls(SEEN)) || 0) >= 3) return;

  // 1re langue du navigateur que le site propose
  var list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  var want = null;
  for (var i = 0; i < list.length; i++) {
    var l = base(list[i]);
    if (Object.prototype.hasOwnProperty.call(roots, l) && T[l]) { want = l; break; }
  }
  if (!want || want === current) return;

  // même page dans la langue proposée : on retire le préfixe de langue actuel (/de, /en…) et on met le nouveau
  function prefix(code) { var r = String(roots[code] || '/'); return r === '/' ? '' : r.replace(/\/$/, ''); }
  // chemin normalisé : jamais « // » au début (une adresse piégée comme pataroc.fr//autre-site.com
  // donnerait sinon un lien vers un autre site)
  var path = '/' + location.pathname.replace(/^\/+/, ''), cur = prefix(current);
  if (cur && (path === cur || path.indexOf(cur + '/') === 0)) path = '/' + path.slice(cur.length).replace(/^\/+/, '');
  var href = (path === '/' ? (prefix(want) || '/') : prefix(want) + path) + location.search + location.hash;
  if (href.charAt(0) !== '/' || /^\/[\/\\]/.test(href)) href = prefix(want) || '/';

  var t = T[want];
  box.setAttribute('lang', want);
  box.setAttribute('aria-label', t.label);
  box.innerHTML = '<p class="pr-lang__text"></p><div class="pr-lang__actions"><a class="pr-btn pr-btn--primary pr-btn--sm pr-lang__go"></a>'
    + '<button type="button" class="pr-lang__no"></button></div>'
    + '<button type="button" class="pr-lang__close"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">'
    + '<path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg></button>';
  box.querySelector('.pr-lang__text').textContent = t.text;
  var go = box.querySelector('.pr-lang__go');
  go.textContent = t.go;
  go.setAttribute('href', href);
  go.setAttribute('hreflang', want);
  box.querySelector('.pr-lang__no').textContent = t.no;
  box.querySelector('.pr-lang__close').setAttribute('aria-label', t.close);

  function hide() {
    ls(DONE, '1');
    box.classList.remove('is-in');
    setTimeout(function () {
      box.removeAttribute('open');
      document.documentElement.classList.remove('pr-lang-open');
    }, 320);
  }
  go.addEventListener('click', function () { ls(DONE, '1'); });
  box.querySelector('.pr-lang__no').addEventListener('click', hide);
  box.querySelector('.pr-lang__close').addEventListener('click', hide);
  box.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); hide(); } });

  // on attend que le bandeau cookies et les autres fenêtres (panier, recherche, offre…) soient fermés
  function busy() {
    if (document.querySelector('dialog[open]:not([data-pr-lang])')) return true;
    var banner = document.getElementById('shopify-pc__banner'); // en position fixe : on teste s'il est rendu
    return !!(banner && banner.getClientRects().length > 0);
  }
  function show() {
    if (ls(DONE)) return;
    if (busy()) { setTimeout(show, 1500); return; }
    // attribut « open » plutôt que show() : la carte n'est pas modale et ne prend pas le focus du visiteur
    box.setAttribute('open', '');
    // sur téléphone, la barre d'achat et la bulle du chat s'effacent le temps de la carte (comme pour les offres)
    document.documentElement.classList.add('pr-lang-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-in'); }); });
    ls(SEEN, String((Number(ls(SEEN)) || 0) + 1));
  }
  setTimeout(show, 1200);
})();
